import styled from "styled-components";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const StyledModalBackground = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 5;
`;

const StyledBottomSheet = styled.div`
  z-index: 6;
  position: fixed;
  width: 80%;
  height: auto;
  max-height: 90%;
  &::-webkit-scrollbar {
    display: none;
  }
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1rem 1rem 0 0;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  text-align: center;
  & > .close {
    height: 46px;
    line-height: 46px;
    color: #4d4d4d;
  }
`;

const StyledBottomSheetContent = styled.div`
  min-height: 14vh;
  padding: 1.4rem 0;
  box-sizing: content-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(102, 102, 102, 1);
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px 12px 0px 0px;

  & > div {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.7rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    color: rgba(0, 200, 140, 1);
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
  }
`;

function Modal({ closeModal, children, navi }) {
  const navigate = useNavigate();
  const [phoneType, setPhoneType] = useState("");

  function checkMobile(){
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    // navigate(navi)
    if (varUA.indexOf("android") > -1) {
      //안드로이드
      // window.postMessageToAndroid.movusCallBack("back");
      setPhoneType("aOS");
      // console.log("aaa")
      return "android";
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      setPhoneType("IOS");
      // console.log("iii")
      // window.webkit.messageHandlers.movusCallBack.postMessage({
      //   command: "back",
      // });
      return "ios";
    } else {
      setPhoneType("other");
      // window.postMessageToAndroid.movusCallBack("back");
      //아이폰, 안드로이드 외
      // console.log("ooo");
      return "other";
    }
  }

  useEffect(() => {
   checkMobile();
  }, []);
  // console.log("NAVI",navi);

  const clickOk = () => {
    // var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    // /**모바일 기종 분기처리 (ios, 안드로이드, 그 외) */
    // if (navi == true) {
    //   // navigate(navi)
    //   if (varUA.indexOf("android") > -1) {
    //     //안드로이드
    //     window.postMessageToAndroid.movusCallBack("back");

    //     return "android";
    //   } else if (
    //     varUA.indexOf("iphone") > -1 ||
    //     varUA.indexOf("ipad") > -1 ||
    //     varUA.indexOf("ipod") > -1
    //   ) {
    //     //IOS
    //     console.log("IOS분기")
    //     window.webkit.messageHandlers.movusCallBack.postMessage({
    //       command: "back",
    //     });
    //     return "ios";
    //   } else {
    //     window.postMessageToAndroid.movusCallBack("back");
    //     //아이폰, 안드로이드 외
    //     return "other";
    //   }
    // }
    if (navi == true) {
      if (phoneType == "aOS") {
        // console.log("aOS분기")
        window.postMessageToAndroid.movusCallBack("back");
      } else if (phoneType == "IOS") {
        window.webkit.messageHandlers.movusCallBack.postMessage({
          command: "back",
        });
        // console.log("IOS분기");
      } else if(phoneType == "other"){
        window.postMessageToAndroid.movusCallBack("back");
        // console.log("OTHER")
      }
    }
    closeModal();
  };

  return (
    <>
      <StyledModalBackground />
      <StyledBottomSheet>
        <StyledBottomSheetContent>
          <div>{children}</div>
        </StyledBottomSheetContent>
        <div className="close" onClick={clickOk}>
          확인
        </div>
      </StyledBottomSheet>
    </>
  );
}

export default Modal;
